// extracted by mini-css-extract-plugin
export default {"contents":"YF-z","sectionHeading":"ZF-z"};